module.exports = __webpack_public_path__ + "static/media/icons.f2785fa3.svg";